export interface TeamRosterSummary {
  id: string
  name: string
  /** `division_uid` from `GET /teams/:teamId/rosters`. */
  divisionUid: string | null
  lockRosterDate: string | null
  isRegistrationOn: boolean
}

/**
 * Picks the roster belonging to the division the user has selected.
 *
 * Returns null rather than falling back to the first roster: a team can be in
 * several competitions, and showing the wrong division's roster would let
 * someone edit players in a competition they did not open.
 */
export const resolveRosterForDivision = (
  rosters: TeamRosterSummary[],
  divisionScheduleId: string
): TeamRosterSummary | null =>
  rosters.find(
    (roster) =>
      roster.divisionUid !== null && roster.divisionUid === divisionScheduleId
  ) ?? null
